import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { useServices } from "@/context/ServicesContext";
import { ClientFields, blankClient } from "@/components/app/ClientFields";

export const NewClientDialog = ({ open, onClose }) => {
  const { bump, openClient } = useServices();
  const [c, setC] = useState(blankClient());
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setC(blankClient()); }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/clients", c);
      toast.success("Cliente cadastrado. Agora adicione os serviços contratados.");
      bump();
      onClose();
      openClient(data.name);
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto border-slate-700 bg-slate-900 sm:max-w-lg" data-testid="new-client-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold">Novo cliente</DialogTitle>
          <DialogDescription>Depois de salvar, a ficha abre para você adicionar os serviços contratados.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <ClientFields c={c} setC={setC} withName />
          <DialogFooter className="gap-2">
            <Button type="button" variant="ghost" onClick={onClose} data-testid="new-client-cancel">Cancelar</Button>
            <Button type="submit" disabled={saving} className="rounded-full font-semibold" data-testid="new-client-submit">
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salvar cliente
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
